//utils file for the EULA pdf file download

export const downloadPDF = pdfurl => {
  var link = document.createElement("a");
  link.download = `agreement.pdf`;
  link.href = pdfurl;
  link.click();
};
